import { numberFormats } from 'config/constants/numberFormats'
import { NumberFormatType } from 'config/constants/types'

const locale = 'en-US'
const TRILLION = 1000000000000

export const formatNumber = (
  number: number | string,
  format: NumberFormatType | Intl.NumberFormatOptions = 'significant',
): string =>
  new Intl.NumberFormat('en-US', typeof format === 'string' ? numberFormats[format] : format).format(Number(number))

export const compactPercentageFormat = (value: number): string => {
  const formatType = value < 100000 ? 'percentage' : 'compactPercent'
  return value < TRILLION ? formatNumber(value / 100, formatType) : '>1T%'
}

export const compactDecimalFormat = (value: number): string => {
  const formatType = value < 100000 ? { maximumFractionDigits: 2, minimumFractionDigits: 2 } : 'compact'
  return value < TRILLION ? formatNumber(value, formatType) : '>1T'
}

export const formatDate = (timestamp: number) => new Date(timestamp).toLocaleDateString(locale)
export const formatTime = (timestamp: number) => new Date(timestamp).toLocaleTimeString(locale)
export const formatDateTime = (timestamp: number) => `${formatDate(timestamp)} ${formatTime(timestamp)}`
